import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import { getEngineConfigs, getEngineConfigRaw, publishEngineConfig, createEngineConfig } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getEngineConfigsWatcher() {
  while (true) {
    const { payload: partner } = yield take(types.GET_ENGINE_CONFIGS_REQUEST);
    try {
      const response = yield call(getEngineConfigs, partner);
      yield put(actions.getEngineConfigsSuccess(response.data.data));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getEngineConfigsFail(e.response ? e.response.data : {}));
    }
  }
}

export function* getEngineConfigRawWatcher() {
  while (true) {
    const { payload: { partner, process, identifierType } } = yield take(types.GET_ENGINE_CONFIG_RAW_REQUEST);
    try {
      const response = yield call(getEngineConfigRaw, partner, process, identifierType);
      yield put(actions.getEngineConfigRawSuccess(response.data.data.yaml));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getEngineConfigRawFail(e.response ? e.response.data : {}));
    }
  }
}

export function* publishEngineConfigWatcher() {
  while (true) {
    const { payload: { partner, process, identifierType, rawYaml } } = yield take(types.PUBLISH_ENGINE_CONFIG_REQUEST);
    try {
      const response = yield call(publishEngineConfig, partner, process, identifierType, rawYaml);
      yield put(actions.publishEngineConfigSuccess(response.data));
      yield put(actions.getEngineConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.publishEngineConfigFail(e.response ? e.response.data : {}));
    }
  }
}

export function* createEngineConfigWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.CREATE_ENGINE_CONFIG_REQUEST);
    try {
      const response = yield call(createEngineConfig, partner, rawYaml);
      yield put(actions.createEngineConfigSuccess(response.data));
      yield put(actions.getEngineConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.createEngineConfigFail(e.response ? e.response.data : {}));
    }
  }
}
